/* Publish by EComposer at 2026-10-03 12:40:14*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-oadyp8j1oqn"]=  window.__ectimmers["ecom-oadyp8j1oqn"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-oadyp8j1oqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oadyp8j1oqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a1aoaqc29lq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a1aoaqc29lq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbxc39mpqr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbxc39mpqr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6sp2uyiki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6sp2uyiki', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wbp4fn0n6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wbp4fn0n6h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gwe6ap2osto').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gwe6ap2osto', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cjyv7weea3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cjyv7weea3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wxtvtmgh25').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wxtvtmgh25', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-auqa3nqj7d4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-auqa3nqj7d4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-195lt9mg0zy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-195lt9mg0zy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zrmdgbqgct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zrmdgbqgct', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xwgxnyd5ezl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xwgxnyd5ezl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8yutlf57od5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8yutlf57od5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6x7ex5t0xz5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6x7ex5t0xz5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zghdh5hm8oc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zghdh5hm8oc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cehq3tftaq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cehq3tftaq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9tb4f3s4ykn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9tb4f3s4ykn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rsu7p69y2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rsu7p69y2c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vv1sxvp2qqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vv1sxvp2qqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s01mczgb46').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s01mczgb46', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mxp74vpsgu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mxp74vpsgu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g24w4ytxzov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g24w4ytxzov', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ace862czna4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ace862czna4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahebons9i6v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahebons9i6v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2tu0acxlt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2tu0acxlt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zzgys0hfei9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zzgys0hfei9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bsornzwr1lm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bsornzwr1lm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a9k3lz5daw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a9k3lz5daw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8f1xctd9isq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8f1xctd9isq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6i346j514ls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6i346j514ls', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3yonw4asdw5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3yonw4asdw5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u0hxb8mtlo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u0hxb8mtlo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gzj5oyaym4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gzj5oyaym4t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lu19ok2nfm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lu19ok2nfm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2u0ej7dtbf6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2u0ej7dtbf6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h83su7a3d6o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h83su7a3d6o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yu942ae53vg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yu942ae53vg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ie61hu4hk1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ie61hu4hk1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6p57a7qu236').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6p57a7qu236', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5pdjpx4bja7"]=  window.__ectimmers["ecom-5pdjpx4bja7"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-5pdjpx4bja7"]["ce0acgqi3"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-5pdjpx4bja7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5pdjpx4bja7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yiihkseawxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yiihkseawxh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yj72ks8glq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yj72ks8glq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xhjzcjw3wld').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xhjzcjw3wld', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l5j7n71v57q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l5j7n71v57q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c68onom224s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c68onom224s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u8da6ue9pg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u8da6ue9pg9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b5ivmzhsfsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b5ivmzhsfsd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hn4s71k6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hn4s71k6h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6g47ofrtrwf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6g47ofrtrwf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k22x8s24hbq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k22x8s24hbq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-em8mh86rkm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-em8mh86rkm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vweja7b0t5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vweja7b0t5i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1w0m871ormd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1w0m871ormd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wtpvhexad49').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wtpvhexad49', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-frixb4jnkhr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-frixb4jnkhr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ekuitz5kea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ekuitz5kea', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fbjsknd8b6g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fbjsknd8b6g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tv7y92na0r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tv7y92na0r', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5218n4ea8se"]=  window.__ectimmers["ecom-5218n4ea8se"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-5218n4ea8se').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5218n4ea8se', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hzf38jiip1f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hzf38jiip1f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b2uaiqwbb0e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b2uaiqwbb0e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vzlxb5jic9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vzlxb5jic9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qti5jqfjddn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qti5jqfjddn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6q4p7lpg1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6q4p7lpg1m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oa6sj2tcx9l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oa6sj2tcx9l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zgg1fly20fq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zgg1fly20fq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xbfzsse4is8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xbfzsse4is8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vs2f3xlip49"]=  window.__ectimmers["ecom-vs2f3xlip49"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,o=this.settings.autoplay,n=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const f=t.querySelector(".ecom-element_video-iframe");n&&setTimeout(function(){b(f)},500);function b($){let A={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,A).observe($)}function y($,A){let I={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){$.readyState>=c&&$.pause()}function T(){$.readyState>=c&&$.play()}function L(){v($,I)}if(r){$.addEventListener("mouseenter",j),$.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),A||$.addEventListener("ended",L)}}function v($,A){if(A){const{handleMouseenter:I,handleMouseleave:j,handleEnded:T}=A;let L=t.querySelector(".ecom-video_link-extra");$.removeEventListener("mouseenter",I),$.removeEventListener("mouseleave",j),$.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",I),L.removeEventListener("mouseleave",j))}}function w($,A){$.forEach(function(I){if(I.isIntersecting){const j=I.target.querySelector("video source"),T=I.target.querySelector("video"),L=I.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){o&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}A.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),S=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),o&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if(S){let $=S.getAttribute("src");$.includes("autoplay=0")?$=$.replace("autoplay=0","autoplay=1"):$=$+"&autoplay=1",S.setAttribute("src",$),l?setTimeout(()=>{$=$.replace("autoplay=1","autoplay=0"),S.setAttribute("src",$)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function($){$.dataset.ecTrackingId&&$.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:$.id,tracking_id:$.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const $=z.dataset.width,A=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:$,height:A};Object.assign(j.style,T)}},onClose:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-vs2f3xlip49').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vs2f3xlip49', settings: {"loop":false,"autoplay":false,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}